/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Markup_PlaceholderInputs */

const cs_templates_ai_markup_placeholder = /** @type {(inputs: Templates_Ai_Markup_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte Markdown nebo HTML obsah…`)
};

const en_templates_ai_markup_placeholder = /** @type {(inputs: Templates_Ai_Markup_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Markdown or HTML body content…`)
};

/**
* | output |
* | --- |
* | "Paste Markdown or HTML body content…" |
*
* @param {Templates_Ai_Markup_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_markup_placeholder = /** @type {((inputs?: Templates_Ai_Markup_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Markup_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_markup_placeholder(inputs)
	return cs_templates_ai_markup_placeholder(inputs)
});